import React, {PropTypes} from 'react';
import { FormGroup, ControlLabel, Button, Row, Col, Modal, HelpBlock } from 'react-bootstrap';
// SHARED
import { FieldGroup } from '../core/components/FieldGroup';
import { ApiHelper } from '../utils/ApiHelper';

const queryString = require('query-string')

export default class CouponField extends React.Component {
  constructor(props){
    super(props)

    this.state = this.initialState()

    this.typingTimer;

  }

  initialState() {
    return {
      coupon: "",
      coupon_val_state: "",
      label: this.props.label
    }
  }


  componentDidMount(){
    const { coupon } = queryString.parse(window.location.search)
    if (coupon) {
      this.handleChange({target: {name: "coupon", value: coupon}})
    }
  }

  handleChange(e) {
    let state = this.state;
    state[e.target.name] = e.target.value;
    state["coupon_val_state"] = "";
    state["label"] = "Checking Coupon...";
    this.setState(state);

    // Pass event to parent
    this.props.onChange(e)

    // Setup typing timer
    clearTimeout(this.typingTimer)
    const timerSeconds = 1500;
    this.typingTimer = setTimeout(function () {

      // Check coupon with server
      ApiHelper.checkCoupon(this.state.coupon).then(response => {
        if (response.status != 201) {
          // Error
          console.log(response.data.error_message);
          state["label"] = "Coupon";
          state["coupon_val_state"] = "error";

          this.setState(state)

          this.props.onReceiveCouponError()

        } else {
          // Success
          state["label"] = "Coupon";
          state["coupon_val_state"] = "success";
          this.setState(state)

          this.props.onReceiveCouponSuccess(response.data)

        }
      }).catch( err => {
        // Error
        console.log(err);
        state["label"] = "Coupon";
        state["coupon_val_state"] = "error";
        this.setState(state)
        this.props.onReceiveCouponError()
      })

    }.bind(this), timerSeconds);

  }

  render() {

    const { id, type, label, placeholder, name, className } = this.props

    return (
      <Col xs={ 12 } sm={ 12 }>
        <FieldGroup
          id={id}
          type={type}
          label={this.state.label}
          placeholder={placeholder}
          name={name}
          value={this.state.coupon}
          onChange={this.handleChange.bind(this)}
          validationState={this.state.coupon_val_state}
          feedbackIcon={true}
          className={className}
        />
      </Col>
    );
  }
}

CouponField.propTypes = {
};



// WEBPACK FOOTER //
// ./src/subscriptions/CouponField.js